import React, {useState} from 'react';
import {HeartIcon, SendHorizontalIcon, SmileIcon} from 'lucide-react';
import {Emoji} from '../../emojis/types.ts';
import EmojiImage from '../../emojis/EmojiImage.tsx';
import {ToolButton, Toolbar, ToolbarDivider} from '../ds/ToolFrame.tsx';

interface ReactionToolbarProps {
    openReactionModal: () => void;
    triggerReactionEvent: ({
        animationType,
        message,
        emoji
    }: {
        animationType: 'float' | 'drop' | 'fly';
        message: string | null;
        emoji: string | null;
    }) => void;
    emoji: Emoji;
}

const ReactionToolbar: React.FC<ReactionToolbarProps> = ({
    openReactionModal,
    triggerReactionEvent,
    emoji
}) => {
    const [message, setMessage] = useState('');

    const sendMessage = () =>
        triggerReactionEvent({animationType: 'fly', message, emoji: null});

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            sendMessage();
        }
    };

    return (
        <Toolbar label="Reactions" className="whiteboard-toolbar">
            <ToolButton
                label="Select Emoji"
                icon={SmileIcon}
                onClick={() => openReactionModal()}
            />
            <ToolButton
                label="Send Emoji"
                onClick={() =>
                    triggerReactionEvent({
                        animationType: 'drop',
                        message: null,
                        emoji: emoji.emojiCode
                    })
                }
            >
                <EmojiImage
                    emojiCode={emoji.emojiCode}
                    style={{width: '20px', height: '20px'}}
                />
            </ToolButton>
            <ToolButton
                label="Heart"
                icon={HeartIcon}
                onClick={() =>
                    triggerReactionEvent({
                        animationType: 'float',
                        message: null,
                        emoji: ':red_heart:'
                    })
                }
            />
            <ToolbarDivider />
            <input
                type="text"
                className="form-control form-control-sm mx-toolbar-input"
                aria-label="Message"
                placeholder="Say something"
                value={message}
                onChange={e => setMessage(e.target.value)}
                onKeyDown={handleKeyDown}
            />
            <ToolButton
                label="Send Message"
                icon={SendHorizontalIcon}
                onClick={sendMessage}
            />
        </Toolbar>
    );
};

export default ReactionToolbar;
